import React, { useEffect, useState } from 'react'
import Footer from '../components/Footer'
import { useNavigate } from 'react-router';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import Swal from 'sweetalert2';
import { MdOutlineDateRange } from "react-icons/md";
import { collection, doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { Col, Container, Row, Table, Pagination, Modal, Button, Form } from 'react-bootstrap';

function LeadsShop() {
    const [leads, setLeads] = useState([]);
    const [expandedIndex, setExpandedIndex] = useState(null);
    const navigate = useNavigate();
    const auth = getAuth();
    const [authLoaded, setAuthLoaded] = useState(false);
    const [loading, setLoading] = useState(true);
    const [uid, setUid] = useState(null);
    const [sortOption, setSortOption] = useState('newest');
    const [selectedPropertyType, setSelectedPropertyType] = useState('');
    const [coordinates, setCoordinates] = useState({}); // Store coordinates for each lead
    const [selectedCity, setSelectedCity] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0); // if your API gives total count


    const [locationInput, setLocationInput] = useState("");
    const [totalPages, setTotalPages] = useState(0);
    const [nextPageUrl, setNextPageUrl] = useState(null);
    const [previousPageUrl, setPreviousPageUrl] = useState(null);

    const stateAbbreviations = {
        "Alabama": "AL", "Alaska": "AK", "Arizona": "AZ", "Arkansas": "AR", "California": "CA",
        "Colorado": "CO", "Connecticut": "CT", "Delaware": "DE", "Florida": "FL", "Georgia": "GA",
        "Hawaii": "HI", "Idaho": "ID", "Illinois": "IL", "Indiana": "IN", "Iowa": "IA",
        "Kansas": "KS", "Kentucky": "KY", "Louisiana": "LA", "Maine": "ME", "Maryland": "MD",
        "Massachusetts": "MA", "Michigan": "MI", "Minnesota": "MN", "Mississippi": "MS", "Missouri": "MO",
        "Montana": "MT", "Nebraska": "NE", "Nevada": "NV", "New Hampshire": "NH", "New Jersey": "NJ",
        "New Mexico": "NM", "New York": "NY", "North Carolina": "NC", "North Dakota": "ND",
        "Ohio": "OH", "Oklahoma": "OK", "Oregon": "OR", "Pennsylvania": "PA", "Rhode Island": "RI",
        "South Carolina": "SC", "South Dakota": "SD", "Tennessee": "TN", "Texas": "TX", "Utah": "UT",
        "Vermont": "VT", "Virginia": "VA", "Washington": "WA", "West Virginia": "WV",
        "Wisconsin": "WI", "Wyoming": "WY"
    };

    const [selectedState, setSelectedState] = useState('');
    const abbreviationsToState = Object.fromEntries(
        Object.entries(stateAbbreviations).map(([state, abbr]) => [abbr, state])
    );
    // const fetchCoordinates = async (city, state) => {
    //     const query = `${city}, ${state}, USA`;
    
    //     try {
    //         const response = await fetch(
    //             `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}`,
    //             {
    //                 headers: {
    //                     'User-Agent': 'SpotYourLeads (support@spotYourLeads.com)' 
    //                 }
    //             }
    //         );
    //         const data = await response.json();
    //         if (data.length > 0) {
    //             return {
    //                 lat: parseFloat(data[0].lat),
    //                 lon: parseFloat(data[0].lon),
    //             };
    //         }
    //     } catch (error) {
    //         console.error('Error fetching coordinates:', error);
    //     }
    //     return null;
    // };
   
    // const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    
    // useEffect(() => {
    //     const fetchAllCoordinates = async () => {
    //         const coords = {};
    //         for (let i = 0; i < leads.length; i++) {
    //             const lead = leads[i];
    //             const coord = await fetchCoordinates(lead.city, lead.state);
    //             if (coord) {
    //                 coords[i] = coord;
    //                 setCoordinates((prev) => ({ ...prev, [i]: coord }));
    
    //                 // ✅ أضف تأخير فقط لو فيه إحداثيات
    //                 await sleep(1000); 
    //             }
    //         }
    //     };
    //     fetchAllCoordinates();
    // }, [leads]);
    const fetchCoordinates = async (city, state) => {
        const apiKey = process.env.REACT_APP_OPEN_CAGE_API_KEY
        const query = `${city}, ${state}, USA`;
    
        try {
            const response = await fetch(
                `https://api.opencagedata.com/geocode/v1/json?q=${encodeURIComponent(query)}&key=${apiKey}`
            );
            const data = await response.json();
    
            if (data.results && data.results.length > 0) {
                const { lat, lng } = data.results[0].geometry;
                return {
                    lat,
                    lon: lng,
                };
            }
        } catch (error) {
            console.error('Error fetching coordinates:', error);
        }
    
        return null;
    };
    
    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    
    useEffect(() => {
        const fetchAllCoordinates = async () => {
            const coords = {};
            for (let i = 0; i < leads.length; i++) {
                const lead = leads[i];
                const coord = await fetchCoordinates(lead.city, lead.state);
                if (coord) {
                    coords[i] = coord;
                    setCoordinates((prev) => ({ ...prev, [i]: coord }));
                    await sleep(1000); // لتجنب تجاوز الحد
                }
            }
        };
        fetchAllCoordinates();
    }, [leads]);
    
  
    
    // const sendToZapierWebhook = async (leadId, userEmailOrId) => {
    //     try {
    //         const lead = leads.find((l) => l.id === leadId); 
    //         if (!lead) return;
    
    //         const webhookUrl = "";
    
    //         const payload = {
    //             purchasedBy: userEmailOrId,
    //             leadId: lead.id,
    //             propertyAddress: lead.propertyAddress,
    //             propertyType: lead.propertyType,
    //             propertyOwner: lead.propertyOwner,
    //             leadNotes: lead.leadTemplate,
    //             sellingReason: lead.sellingReason,
    //             hasMortgage: lead.hasMortgage,
    //             ownedYears: lead.ownedYears,
    //             livingStatus: lead.livingStatus,
    //             propertyListed: lead.propertyListed,
    //             phoneNumber: lead.phoneNumber,
    //             repairsNeeded: Array.isArray(lead.repairsNeeded) 
    //               ? lead.repairsNeeded.join(', ') 
    //               : '',
    //             state: lead.state,
    //             city: lead.city,
    //             closingTime: lead.closingTime,
    //             price: lead.price
    //         };
    
    //         await fetch(webhookUrl, {
    //             method: 'POST',
    //             mode: "no-cors",
    //             headers: {
    //                 "Content-Type": "application/json"
    //             },
    //             body: JSON.stringify(payload)
    //         });
    //     } catch (error) {
    //         console.error("Failed to send to Zapier:", error);
    //     }
    // };

    const BuyLead = async (leadId , leadDate,status) => {
        const leadDateObj = new Date(leadDate * 1000);
        // const now = new Date();
        // const diffMs = now - leadDateObj;
        // const oneWeekMs = 7 * 24 * 60 * 60 * 1000;
        
        let htmlContent = `<p>Do you want to purchase this lead?</p>`;
        if (status == "old") {
          const formattedDate = leadDateObj.toLocaleString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
          }).replace(',', ''); 
        
          htmlContent += `
            <hr style="border-top: 1px solid #ddd;" />
            <p><strong>Lead Date:</strong> ${formattedDate}</p>
          `;
        }
        
        const result = await Swal.fire({
            title: "Do you want to purchase this lead?",
            icon: "question",
            html: htmlContent, 
            showCancelButton: true,
            confirmButtonText: "Yes, buy it!",
            cancelButtonText: "No, cancel",
            customClass: {
                confirmButton: "my-confirm-button",
                cancelButton: "my-cancel-button",
            }
        });
        const payload = {
            leadId: leadId,
            userId: uid
        }

        if (result.isConfirmed) {
            try {
                const url = `https://api.v1.spotyourleads.com/lead/purchase`;

                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'x-api-key': process.env.REACT_APP_API_KEY,
                        "Content-Type": "application/json",

                    },
                    body: JSON.stringify(payload)
                });

                if (!response.ok) {
                    throw new Error('Failed to purchase lead. Please try again.');
            
                }

                const data = await response.json();

                Swal.fire({
                    icon: 'success',
                    title: data.message,
                    customClass: {
                        confirmButton: 'my-confirm-button',
                    }
                });
                // sendToZapierWebhook(leadId, uid);

            } catch (error) {
                // console.error('Error purchasing lead:', error);
                Swal.fire({
                    icon: 'error',
                    title: error.message || 'An unexpected error occurred. Please try again.',
                    customClass: {
                        confirmButton: 'my-confirm-button',
                    }
                });
            }
        }
    };

    const BuyUserLead = async (leadId) => {
        const { value: email } = await Swal.fire({
            title: 'Enter your email',
            input: 'email',
            inputLabel: 'Email',
            inputPlaceholder: 'Enter your email',
            showCancelButton: true,
            confirmButtonText: 'Continue',
            cancelButtonText: 'Cancel',
            customClass: {
                confirmButton: 'my-confirm-button',
                cancelButton: 'my-cancel-button',
            },
            inputValidator: (value) => {
                if (!value) {
                    return 'Email is required!';
                }
            }
        });
    
        if (!email) return;
    
        const confirmResult = await Swal.fire({
            title: `Do you want to purchase this lead using\n${email}?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Yes, buy it!",
            cancelButtonText: "No, cancel",
            customClass: {
                confirmButton: "my-confirm-button",
                cancelButton: "my-cancel-button",
            }
        });
    
        if (!confirmResult.isConfirmed) return;
    
        const payload = {
            leadId: leadId,
            userId: email
        };
    
        try {
            const url = `https://api.v1.spotyourleads.com/lead/purchase`;
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'x-api-key': process.env.REACT_APP_API_KEY,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload)
            });
    
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                const msg = errorData.message || 'Failed to purchase lead. Please try again.';
                return Swal.fire({
                    icon: 'error',
                    title: msg,
                    customClass: { confirmButton: 'my-confirm-button' }
                });
            }
    
            const data = await response.json();
            Swal.fire({
                icon: 'success',
                title: data.message,
                customClass: { confirmButton: 'my-confirm-button' }
            });
    
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: error.message || 'An unexpected error occurred. Please try again.',
                customClass: { confirmButton: 'my-confirm-button' }
            });
        }
    };
    
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                setUid(user.uid);
            } else {
                setUid(null);
                navigate('/sign-in');
            }
        });
        return () => unsubscribe();
    }, [auth, navigate]);
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                setAuthLoaded(true); // Auth state has loaded
            } else {
                setAuthLoaded(false);
            }
        });

        return () => unsubscribe(); // Clean up listener on unmount
    }, [auth]);
    // const fetchCoordinates2 = async (location) => {
    //     try {
    //         console.log("Fetching coordinates for:", location);

    //         const response = await fetch(
    //             `https://nominatim.openstreetmap.org/search?format=json&countrycodes=US&q=${encodeURIComponent(location)}`
    //         );

    //         const data = await response.json();
    //         console.log("API Response:", data);

    //         if (data.length > 0) {
    //             const { lat, lon, display_name } = data[0];

    //             const addressParts = display_name.split(", ");
    //             const state = addressParts.find((part) =>
    //                 part.match(/\b(Alabama|Alaska|Arizona|Arkansas|California|Colorado|Connecticut|Delaware|Florida|Georgia|Hawaii|Idaho|Illinois|Indiana|Iowa|Kansas|Kentucky|Louisiana|Maine|Maryland|Massachusetts|Michigan|Minnesota|Mississippi|Missouri|Montana|Nebraska|Nevada|New Hampshire|New Jersey|New Mexico|New York|North Carolina|North Dakota|Ohio|Oklahoma|Oregon|Pennsylvania|Rhode Island|South Carolina|South Dakota|Tennessee|Texas|Utah|Vermont|Virginia|Washington|West Virginia|Wisconsin|Wyoming)\b/)
    //             );

    //             console.log("Extracted State:", state);

    //             return { lat, lon, state };
    //         }
    //     } catch (error) {
    //         console.error("Error fetching coordinates:", error);
    //     }
    //     return null;
    // };
    const handleLocationInput = (event) => {
        const input = event.target.value.trim().toLowerCase();
        setLocationInput(event.target.value);

        // Reset state and city if input is empty
        if (input === "") {
            setSelectedState("");
            setSelectedCity("");
            return;
        }

        // Check if input matches a state name
        const matchedState = Object.keys(stateAbbreviations).find(state => state.toLowerCase() === input);
        if (matchedState) {
            setSelectedState(matchedState);
            setSelectedCity(""); // Reset city if state is selected
            return;
        }

        // Check if input matches a city from leads
        const matchedLead = leads.find(lead => lead.city.toLowerCase() === input);
        if (matchedLead) {
            setSelectedState(matchedLead.state);
            setSelectedCity(matchedLead.city);
        }
    };
    const fetchLeads = async (pageNumber, customUrl = null, filters = {}) => {
        try {
            const queryParams = new URLSearchParams(window.location.search);
            const type = queryParams.get('type') || 'available';

            const user = auth.currentUser;
            if (!user) throw new Error('User not authenticated.');

            const userId = user.uid;

            let apiUrl;
            if (customUrl) {
                apiUrl = `https://api.v1.spotyourleads.com${customUrl}`;
            } else {
                const query = new URLSearchParams({
                    type,
                    userId,
                    page: pageNumber,
                    limit: 10,
                    ...(filters.city && { city: filters.city }),
                    ...(filters.state && { state: filters.state }),
                    ...(filters.propertyType && { propertyType: filters.propertyType }),
                    ...(filters.sortBy && { sortBy: filters.sortBy }),
                });

                apiUrl = `https://api.v1.spotyourleads.com/lead?${query.toString()}`;
            }

            const response = await axios.get(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': process.env.REACT_APP_API_KEY,
                },
            });

            const pagination = response.data.pagination;

            setLeads(response.data.leads);
            setTotalPages(pagination.totalPages);
            setNextPageUrl(pagination.nextPageUrl || null);
            setPreviousPageUrl(pagination.previousPageUrl || null);
        } catch (error) {
            console.error('Error fetching leads:', error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (!uid) return;

        const unsubscribe = onSnapshot(
            collection(db, "leads"),
            () => {
                fetchLeads(currentPage, null, {
                    city: locationInput,
                    state: selectedState,
                    propertyType: selectedPropertyType,
                    sortBy: sortOption,
                });
            },
            (error) => {
                console.error("Firestore onSnapshot error:", error);
            }
        );

        return () => unsubscribe();
    }, [uid, selectedCity, selectedState, selectedPropertyType, locationInput, sortOption, currentPage]);

    // const handleSortChange = (e) => {
    //     const option = e.target.value;
    //     setSortOption(option);

    //     let sortedLeads = [...leads];

    //     if (option === 'oldest') {
    //         sortedLeads.reverse();
    //     } else if (option === 'highestPrice') {
    //         sortedLeads = sortedLeads.sort((a, b) => b.price - a.price);
    //     } else if (option === 'lowestPrice') {
    //         sortedLeads = sortedLeads.sort((a, b) => a.price - b.price);
    //     }

    //     setLeads(sortedLeads);
    // };
    // const filteredLeads = Array.isArray(leads) ? leads.filter(lead =>
    //     (!selectedState || lead?.state === selectedState) &&
    //     (!selectedCity || lead?.city?.toLowerCase()?.includes(selectedCity?.toLowerCase())) &&
    //     (!selectedPropertyType || lead?.propertyType === selectedPropertyType)
    // ) : [];
    const handlePageChange = (pageNumber, url = null) => {
        setCurrentPage(pageNumber);
        fetchLeads(pageNumber, url);
    };
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = leads?.slice(indexOfFirstRow, indexOfLastRow);
    const renderPagination = () => {
        const pageNumbers = [];

        if (currentPage > 1) {
            pageNumbers.push(
                <Pagination.Item key={currentPage - 1} onClick={() => handlePageChange(currentPage - 1, previousPageUrl)}>
                    {currentPage - 1}
                </Pagination.Item>
            );
        }

        pageNumbers.push(
            <Pagination.Item key={currentPage} active>
                {currentPage}
            </Pagination.Item>
        );

        if (currentPage < totalPages) {
            pageNumbers.push(
                <Pagination.Item key={currentPage + 1} onClick={() => handlePageChange(currentPage + 1, nextPageUrl)}>
                    {currentPage + 1}
                </Pagination.Item>
            );
        }

        return (
            <Pagination>
                <Pagination.Prev
                    className={previousPageUrl ? "active" : null}

                    disabled={!previousPageUrl}
                    onClick={() => handlePageChange(currentPage - 1, previousPageUrl)}
                />
                {pageNumbers}
                <Pagination.Next
                    className={nextPageUrl ? "active" : null}
                    disabled={!nextPageUrl}
                    onClick={() => handlePageChange(currentPage + 1, nextPageUrl)}
                />
            </Pagination>
        );
    };

    const handleSortChange = (e) => {
        const option = e.target.value;
        setSortOption(option);

        fetchLeads(1, null, {
            city: locationInput,
            state: selectedState,

            propertyType: selectedPropertyType,
            sortBy: option,
        });
    };
    return (
        <>
            <Helmet>
                <title>Spot Your Leads |  Buy Real Estate Leads Instantly </title>
            </Helmet>


            <section className="leadsShop" >
                <Container>

                    <div className='pricing-title'>
                        <h2>Leads Shop</h2>
                        <h3>Introduction:</h3>
                        <h5>"Find. Claim. Close. Your Ideal Leads Await."</h5>
                        <p>
                            <span>Spot Your Lead</span> simplifies your search for real estate opportunities.
                            Explore our extensive database of verified leads, filter by your preferences,
                            and start closing deals today.
                        </p>
                    </div>
                    <div>

                        <div className="inquiry">
                            <Container>
                                <Row>
                                    <Col lg={12} md={12} sm={12}>
                                        <div className="formDiv">

                                            <form
                                            // onSubmit={handlePasswordChange}
                                            >
                                                <div className='row justify-content-between mt-1'>
                                                    <div className='col-md-6'>
                                                        <input
                                                            className="form-control"
                                                            name="location"
                                                            type="text"
                                                            placeholder="Enter City"
                                                            value={locationInput}
                                                            onChange={(e) => setLocationInput(e.target.value)}

                                                        />
                                                    </div>
                                                    <div className='col-md-3'>
                                                        <select
                                                            className="form-control"
                                                            value={selectedState}
                                                            onChange={(e) => setSelectedState(e.target.value)}
                                                        >
                                                            <option value="">Select State</option>
                                                            {Object.entries(stateAbbreviations).map(([fullName, abbreviation]) => (
                                                                <option key={abbreviation} value={abbreviation}>{abbreviation}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className='col-md-3'>
                                                        <select
                                                            className="form-control"
                                                            name="propertyType"
                                                            value={selectedPropertyType}
                                                            onChange={(e) => setSelectedPropertyType(e.target.value)} // Update selected property type
                                                        >
                                                            <option value="">Property Type</option>
                                                            <option value="Single family">Single family</option>
                                                            <option value="Ranch">Ranch</option>
                                                            <option value="2-story">2-story</option>
                                                            <option value="Mobile home owned land">Mobile home owned land</option>
                                                            <option value="Mobile home rented land">Mobile home rented land</option>
                                                            <option value="Multifamily">Multifamily</option>
                                                            <option value="Bungalow">Bungalow</option>
                                                            <option value="Cottage">Cottage</option>
                                                            <option value="Townhouse">Townhouse</option>
                                                            <option value="Condominium">Condominium</option>
                                                            <option value="Duplex">Duplex</option>
                                                            <option value="Farmhouse">Farmhouse</option>
                                                            <option value="Split-level home">Split-level home</option>
                                                            <option value="Land">Land</option>
                                                            <option value="Commercial Property">Commercial Property</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className='row justify-content-end mt-1'>

                                                    <div className='col-md-8 sortby'>
                                                        <label>Sort by</label>
                                                        <select
                                                            className="form-control"
                                                            name="sort"
                                                            onChange={handleSortChange}
                                                            value={sortOption}
                                                        >
                                                            <option value="newest">Newest</option>
                                                            <option value="oldest">Oldest</option>
                                                            <option value="highestPrice">Highest Price</option>
                                                            <option value="lowestPrice">Lowest Price</option>
                                                        </select>


                                                    </div>

                                                </div>
                                            </form>

                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                        <Container>
                            <Row>
                                {leads?.map((lead, index) => (
                                    <Col key={index} lg={12} md={12} sm={12}>
                                        <div
                                            className="leads-items row"
                                            style={{
                                                border: '1px solid #ddd',
                                                marginBottom: '15px',
                                                padding: '15px',
                                                borderRadius: '5px',
                                              }}
                                        >
                                            {lead.status == "discounted" || lead.status == "old" ? <span className="leads-shop-badge"></span> : lead.status == "free" ? <span className="leads-shop-badge2"></span> : null}
                                            <div className='col-md-4'>


                                                {coordinates[index] && (
                                                    <iframe
                                                        src={`https://maps.google.com/maps?q=${coordinates[index].lat},${coordinates[index].lon}&z=10&output=embed`}
                                                        loading="lazy"
                                                        referrerPolicy="no-referrer-when-downgrade"
                                                        style={{ width: '100%', height: '300px' }}
                                                    ></iframe>
                                                )}
                                            </div>
                                            <div className='col-md-4'>
                                                <p className='date-lead'>
                                                    <MdOutlineDateRange />

                                                    {new Date(lead.acceptedAt * 1000).toLocaleDateString('en-GB', {
                                                        day: '2-digit',
                                                        month: 'long',
                                                        year: 'numeric'
                                                    })}{' '}
                                                    {new Date(lead.acceptedAt * 1000).toLocaleTimeString('en-US', {
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                        hour12: true
                                                    }).toLowerCase()}
                                                </p>
                                                {/* <p>
                                                    <strong>Price:</strong> {lead.status == "discounted" ? <span><del style={{ fontSize: "12px", color: "gray" }}>${lead.basePrice}</del>  ${lead.price} </span> : '$' + lead.price}  {lead.status == "discounted" || lead.status == "free" ? <span className="leads-shop-badge">{lead.status == "discounted" ? "50% off" : lead.status}</span> : null} <br />
                                                </p> */}
                                                <p>
                                                    <strong>Address:</strong> {lead.propertyAddress} <br />
                                                </p>

                                                <p>
                                                    <strong>Property Type:</strong> {lead.propertyType} <br />
                                                </p>
                                                <p>
                                                    <strong>Owner:</strong> {lead.propertyOwner} <br />
                                                </p>
                                                <p>
                                                    <strong>Lead Notes:</strong>                                                 
                                                    <div dangerouslySetInnerHTML={{ __html: lead.leadTemplate }} />

                                                </p>
                                                <p>
                                                    <strong>Reason for Selling:</strong> {lead.sellingReason} <br />
                                                </p>
                                                <p>
                                                    <strong>Mortgage:</strong> {lead.hasMortgage} <br />
                                                </p>
                                                <p>
                                                    <strong>Source:</strong> {lead.source} <br />
                                                </p>


                                            </div>
                                            <div className='col-md-4'>



                                                <p>
                                                    <strong>Owned Years:</strong> {lead.ownedYears} <br />
                                                </p>

                                                <p>
                                                    <strong>Occupancy :</strong> {lead.livingStatus} <br />
                                                </p>
                                                <p>
                                                    <strong>Property Listed:</strong> {lead.propertyListed} <br />
                                                </p>
                                                <p>
                                                    <strong>Phone Number:</strong> {lead.phoneNumber} <br />
                                                </p>
                                                <p>

                                                    <strong>Repairs Needed:</strong> <span style={{ fontSize: "14px", color: "#1f1f1f" }}> {lead?.repairsNeeded?.filter(item => lead?.repairsNeeded.includes(item))
                                                        .join(", ") + "."}</span><br />
                                                </p>
                                                <p>
                                                    <strong>State:</strong> {lead.state} <br />
                                                </p>
                                                <p>
                                                    <strong>City:</strong> {lead.city} <br />
                                                </p>



                                                <p>
                                                    <strong>Closing Time:</strong> {lead.closingTime} <br />
                                                </p>
                                                {localStorage.getItem("isAdmin") === "true" ?
                                                <button
                                                    onClick={() => BuyUserLead(lead.id)}
                                                    style={{
                                                        marginBottom: '10px',
                                                        cursor: 'pointer',
                                                        padding: '5px 0px',
                                                        backgroundColor: '#007bff',
                                                        color: '#fff',
                                                        border: 'none',
                                                        borderRadius: '5px',
                                                        width: "200px"
                                                    }}
                                                >
                                                    Buy User A Lead
                                                </button>
                                                :null}
                                                <button
                                                    onClick={() => BuyLead(lead.id , lead.acceptedAt, lead.status)}
                                                    style={{
                                                        marginBottom: '10px',
                                                        cursor: 'pointer',
                                                        padding: '5px 0px',
                                                        backgroundColor: '#007bff',
                                                        color: '#fff',
                                                        border: 'none',
                                                        borderRadius: '5px',
                                                        width: "200px"
                                                    }}
                                                >
                                                    {lead.status == "discounted" || lead.status == "old" ? <> <del style={{ fontSize: "12px", color: "gray" }}>${lead.basePrice}</del> <span style={{ fontSize: "15px", marginRight: "10px" }}>${lead.price}</span></> : <span style={{ fontSize: "15px", marginRight: "10px" }}>${lead.price}</span>} Buy Lead
                                                </button>

                                            </div>

                                        </div>


                                    </Col>
                                ))}

                            </Row>
                        </Container>
                        {renderPagination()}
                    </div>
                </Container>
            </section>
            <Footer />
        </>
    )
}

export default LeadsShop
